import React from 'react'

import AddSubTypeForm from '../../modules/SubType/components/AddSubTypeForm'
export default function AddSubTypePage() {
  return <AddSubTypeForm />
}
